import React, { useState } from 'react';
import {
  Box,
  Modal,
  IconButton,
  Card,
  CardMedia,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ImagePreview = ({ imageUrl, alt, aspectRatio = '16/9', height, width, onClick }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (onClick) {
      onClick();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => setOpen(false);

  if (!imageUrl) return null;

  return (
    <>
      <Card 
        sx={{ 
          cursor: 'pointer',
          overflow: 'hidden',
          borderRadius: 2,
          width: width || '100%',
          height: height,
          '&:hover': {
            '& .MuiCardMedia-root': {
              transform: 'scale(1.05)',
              transition: 'transform 0.3s ease-in-out'
            }
          }
        }}
        onClick={handleOpen}
      >
        <CardMedia
          component="img"
          image={imageUrl}
          alt={alt}
          sx={{
            width: '100%',
            height: height || '100%',
            aspectRatio: aspectRatio,
            objectFit: 'cover',
            transition: 'transform 0.3s ease-in-out'
          }}
        />
      </Card>

      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2
        }}
      >
        <Box
          sx={{
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            outline: 'none'
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: -16,
              top: -16,
              bgcolor: 'background.paper',
              '&:hover': {
                bgcolor: 'background.paper',
              },
              zIndex: 1
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={imageUrl}
            alt={alt}
            style={{
              maxWidth: '100%',
              maxHeight: '90vh',
              objectFit: 'contain',
              borderRadius: 8,
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default ImagePreview; 